const TripStyle = (theme) => {
    return {
        rooted: {
            display: "flex",
        },
        formControl: {
            //margin: theme.spacing(1),
            width: 200
        },
        root: {
            flexGrow: 1,
            height: 250,
        },
        container: {
            flexGrow: 1,
            position: "relative",
        },
        paper: {
            position: "absolute",
            zIndex: 1,
            marginTop: theme.spacing(1),
            left: 0,
            right: 0,
        },
        chip: {
            margin: theme.spacing(0.5, 0.25),
        },
        inputRoot: {
            flexWrap: "wrap",
        },
        inputInput: {
            width: "auto",
            flexGrow: 1,
        },
        divider: {
            height: theme.spacing(2),
        },
        progress: {
            margin: theme.spacing(2),
        },

        priceTooltip: {
            width: 400,
            minWidth: 400,
            maxWidth: 400,
        },

        gridRoot: {
            flexGrow: 1,
        },
        gridPaper: {

        },
        gridControl: {
            padding: theme.spacing(2),
        },
        formRoot: {
            '& .MuiTextField-root': {
                margin: theme.spacing(1),
                width: '25ch',
            },
            '& .MuiTypography-h6': {
                fontSize: 1.25,
                fontFamily: "Ubuntu,sans-serif",
                fontWeight: 500,
                lineHeight: 1.6,
                letterSpacing: 0.0075,
            },
            '& .MuiTypography-root': {
                margin: 0
            }
        },
        avatar: {
            width: theme.spacing(4),
            height: theme.spacing(4),
        },
        dateSelector: {
          marginTop: 0,
          marginBottom: 0,
        },
        scheduledTripLegEditor: {
            "& .MuiTableHead-root": {
                backgroundColor: theme.palette.childTableHeader.backgroundColor,
                display: "block",
                tableLayout: "fixed",
                paddingRight: 20,
            },
            "& .MuiTableSortLabel-root": {
                color: theme.palette.secondary.main,
            }
        },
        TripLegEditor: {
            "& .MuiTableHead-root": {
                backgroundColor: theme.palette.childTableHeader.backgroundColor,
                display: "block",
                tableLayout: "fixed",
                paddingRight: 20,
            },
            "& .MuiTableSortLabel-root": {
                color: theme.palette.secondary.main,
            }
        },
        PassportEditor: {
            "& .MuiTableHead-root": {
                backgroundColor: theme.palette.childTableHeader.backgroundColor,
                display: "block",
                tableLayout: "fixed",
                paddingRight: 20,
            },
            "& .MuiTableSortLabel-root": {
                color: theme.palette.secondary.main,
            }
        },
        contractTooltip: {
            width: 350,
            minWidth: 350,
            maxWidth: 350,
        },  
        contractTooltipSmall: {
            width: 250,
            minWidth: 250,
            maxWidth: 250,
        },  
    }
}

export default TripStyle;
